const WD = ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'];

export function isoAddDays(iso, n) {
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + n);
  return dt.toISOString().slice(0, 10);
}

export function buildDays(startIso, num) {
  return Array.from({ length: num }, (_, i) => isoAddDays(startIso, i));
}

export function weekdayShort(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  return WD[new Date(Date.UTC(y, m - 1, d)).getUTCDay()];
}

export function dayNum(iso) {
  return Number(iso.split('-')[2]);
}

export function isWeekend(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  const wd = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return wd === 0 || wd === 6;
}

export function monthLabel(iso) {
  const [y, m] = iso.split('-').map(Number);
  const months = ['Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún', 'Júl', 'August', 'September', 'Október', 'November', 'December'];
  return `${months[m - 1]} ${y}`;
}

const WD_FULL = ['Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota', 'Nedeľa'];

export function pyWeekday(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  return (new Date(Date.UTC(y, m - 1, d)).getUTCDay() + 6) % 7; // 0=Po .. 6=Ne
}

export function dayFull(iso) {
  return WD_FULL[pyWeekday(iso)];
}

export function fullDate(iso) {
  const [y, m, d] = iso.split('-');
  return `${d}.${m}.${y}`;
}
